// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"333":"2361ab8b","692":"4413c3c1"}[chunkId] + ".chunk.js";
};